import axios from "axios";
import config from "./config";
export default {
    async getDefault(entity) {
        try {
            let list = await axios.get(config.app_url == undefined ? "" : config.app_url + "fields/" + entity, {
                headers: {
                    Authorization: "Bearer " + window.localStorage.getItem("openkit"),
                },
            });
            return list.data;
        }
        catch (error) {
            return null;
        }
    },
    async find(entity) {
        try {
            let list = await axios.get(config.app_url == undefined ? "" : config.app_url + "fields/" + entity, {
                headers: {
                    Authorization: "Bearer " + window.localStorage.getItem("openkit"),
                },
            });
            return list.data;
        }
        catch (error) {
            return null;
        }
    },
    async create(entity, field) {
        try {
            let list = await axios.post(config.app_url == undefined ? "" : config.app_url + "fields/" + entity, field, {
                headers: {
                    Authorization: "Bearer " + window.localStorage.getItem("openkit"),
                },
            });
            return list;
        }
        catch (error) {
            return null;
        }
    },
    async update(entity, id, field) {
        let reply = await axios.post(config.app_url == undefined
            ? ""
            : config.app_url + "fields/" + entity + "/" + id, field, {
            headers: {
                Authorization: "Bearer " + window.localStorage.getItem("openkit"),
            },
        });
        return reply;
    },
};
